import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { OMSSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerOMSSettings/types';
import { OMSSchedulerSettingsRulesForm } from '@lp/features/Scheduler/SchedulerOMSSettings/components';
import {
  omsSchedulerSettingsRulesFormSchema,
  getDefaultOMSSchedulerRulesValues,
  getOMSSchedulerRulesSettingsFromForm,
} from '@lp/features/Scheduler/SchedulerOMSSettings/config';
import { useOMSScheduleSettingsRulesQuery, useOMSSetScheduleSettingsRulesMutation } from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const OMSSchedulerSettingsRulesTab = () => {
  const { checkPermission } = useAuthContext();
  const { data } = useOMSScheduleSettingsRulesQuery();
  const { mutateAsync, isPending } = useOMSSetScheduleSettingsRulesMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.OMSSchedulesSettingsRulesWrite);

  const handleSubmit = async (formData: OMSSchedulerSettingsRulesFormType) => {
    try {
      const body = getOMSSchedulerRulesSettingsFromForm(formData);
      await mutateAsync(body);
      toast.success(`Scheduler Rules updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex flex-col">
      {data ? (
        <Form<OMSSchedulerSettingsRulesFormType>
          defaultValues={getDefaultOMSSchedulerRulesValues(data)}
          schema={omsSchedulerSettingsRulesFormSchema}
          onSubmit={handleSubmit}
        >
          <OMSSchedulerSettingsRulesForm isReadOnly={!hasWritePermissions} />
          <SchedulerSettingsSubmitRow
            backPath="/schedule/oms"
            isLoading={isPending}
            isReadOnly={!hasWritePermissions}
          />
        </Form>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
